<template>
  <div class="link-box">
    <ul>
      <li class="title">友情链接：</li>
      <li><a href="http://www.nhc.gov.cn" target="_blank">国家卫生健康委</a></li>
      <li><a href="http://www.natcm.gov.cn" target="_blank">国家中医药管理局</a></li>
      <li><a href="http://www.moe.gov.cn" target="_blank">国家教育部</a></li>
      <li><a href="https://www.mps.gov.cn" target="_blank">国家公安部</a></li>
      <li><a href="https://www.chinacdc.cn" target="_blank">中国疾病预防控制中心</a></li>
      <li><a href="https://www.nmpa.gov.cn" target="_blank">国家药品监督管理局</a></li>
      <li><a href="https://www.who.int" target="_blank">世界卫生组织</a></li>
      <li><a href="https://www.cma.org.cn" target="_blank">中华医学会</a></li>
      <li class="end"><a @click="moreLink">&middot;&middot;&middot; More</a></li>
    </ul>
    <ul>
      <li class="title">关 键 词：</li>
      <li>进修招生信息平台</li>
      <li>住培招生信息平台</li>
      <li>医学教育管理系统</li>
      <li>医学进修管理系统</li>
      <li>全科培训管理系统</li>
      <li>教学管理系统</li>
      <li>实习管理系统</li>
      <li>本科教学管理系统</li>
      <li class="end"><a  @click="visible = true">&middot;&middot;&middot; More</a></li>
    </ul>
     <a-modal v-model="visible" cancelText="关闭" title="关 键 词" >
      <template slot="footer">
                <a-button @click="handleCancel">关闭</a-button>
              </template>
      <div class="modal-box">
        <ul>
          <li>进修招生信息平台</li>
          <li>住培招生信息平台</li>
          <li>医学教育管理系统</li>
          <li>医学进修管理系统</li>
          <li>全科培训管理系统</li>
          <li>教学管理系统</li>
          <li>实习管理系统</li>
          <li>本科教学管理系统</li>
        </ul>
      </div>
    </a-modal>
  </div>
  
</template>

<script>
export default {
  data(){
    return {
      visible:false
    }
  },
  methods:{
    moreLink(){
      this.$router.push({ path: `/link`})
    },
    handleCancel(){
      this.visible = false
    }
  }
}
</script>

<style lang="less" scoped>
.link-box {
  margin: 12px 0;
  padding: 16px 24px 4px 24px;
  background: #fff;
  border-radius:4px;
  ul {
    display: flex;
    list-style: none;
    padding:0 0 12px 0;
  }
  li {
    width: 130px;
     overflow: hidden;
     text-overflow: ellipsis;
     white-space: nowrap;
     text-align: center;
     font-size: 14px;
    &.title{
      font-size: 14px;
      font-weight: bold;
      width: 90px;
      text-align: left;
     
    }
    &.end{
      font-weight: bold;
      width: 90px;
    }
  }
}
.modal-box{
  ul {
    display: flex;
    list-style: none;
    flex-wrap: wrap;
  }
  li {
    width: 50%;
     padding:6px 0;
  }
}
</style>